import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'

import { Observable } from 'rxjs'

import { ApiHttpService } from '@flowx/designer/shared/api/api-http.service'

import { Theme } from './theme-model'

import { Platform } from '../model/platform.model'

@Injectable({
  providedIn: 'root',
})
export class FlxThemeApiService extends ApiHttpService {
  themeUrl = 'cms/api'

  constructor() {
    const baseUrl = inject<string>('BASE_URL' as any)
    const httpClient = inject(HttpClient)
    super(baseUrl, httpClient)
  }

  getTheme(flowxUuid?: Theme['flowxUuid']): Observable<Theme> {
    return this.get(`${this.themeUrl}/themes/${flowxUuid}`)
  }

  getCompiledTheme(flowxUuid?: Theme['flowxUuid'], platform?: Platform): Observable<Theme> {
    return this.get(`${this.themeUrl}/themes/${flowxUuid}/platform/${platform}/compiled`)
  }

  // TODO Theming: type updates
  updateTheme(flowxUuid: Theme['flowxUuid'], updates: any): Observable<any> {
    return this.patch(`${this.themeUrl}/themes/${flowxUuid}`, { updates })
  }

  updateThemeName(flowxUuid: Theme['flowxUuid'], name: string): Observable<any> {
    return this.patch(`${this.themeUrl}/themes/${flowxUuid}/name`, { name })
  }

  export(flowxUuid: Theme['id']): Observable<Record<any, any>> {
    return this.get(`appmanager/api/resource/themes/${flowxUuid}/export`)
  }
}
